/**
 * Single source of truth for the gatsby-plugin-intl setup.
 * Consumed by gatsby-config.js (build time) and browser runtime code.
 */
module.exports = {
  path: `${__dirname}/locales`,
  languages: ['de', 'en'],
  defaultLanguage: 'de',
  /**
   * Native language titles for locale codes, shown in the language switcher dropdown.
   * Unknown codes fall back to the raw code.
   */
  localeTitles: {
    de: 'Deutsch',
    'de-AT': 'Deutsch',
    en: 'English',
  },
  /**
   * gatsby-plugin-intl's own redirect stays disabled: language detection and
   * persistence live in gatsby-browser.js (onClientEntry / onRouteUpdate) —
   * two redirect flows would race each other.
   */
  redirect: false,
  /**
   * localStorage key with the LP's own language preference.
   * NOTE: `intl-language` is intentionally NOT used — the main Nuxt app owns
   * that key (Austrian user-group marker in mixins/auth/landing-user-group.js).
   */
  storageKey: 'lp-language',
  /**
   * Read-only migration fallbacks: written by previous versions of this LP or
   * by gatsby-plugin-intl itself. Read in resolveLanguage, never deleted —
   * `intl-language` is also the Austrian user-group marker owned by the Nuxt
   * app (mixins/auth/landing-user-group.js).
   */
  legacyStorageKeys: ['intl-language', 'gatsby-intl-language'],
  /**
   * Keys actively removed by persistLanguage after migration.
   * NOTE: `intl-language` intentionally NOT here.
   */
  legacyCleanupKeys: ['gatsby-intl-language'],
  /**
   * Cookie shared with the main Nuxt app: nuxt-i18n reads/writes
   * `i18n_redirected` (detectBrowserLanguage.cookieKey). Both sides persisting
   * the same cookie gives bidirectional LP ↔ app language sync without a backend.
   * ALWAYS host-only (no `domain=`): the app lives on the same host (`/app`),
   * and a second domain-scoped copy would shadow the fresh value.
   * persistLanguage additionally expires the legacy `.pinga.app` variant.
   */
  cookie: {
    key: 'i18n_redirected',
    maxAgeDays: 365,
    sameSite: 'lax',
  },
};
